import { render, staticRenderFns } from "./FileDownloadBadge.vue?vue&type=template&id=b6c06554&functional=true"
import script from "./FileDownloadBadge.vue?vue&type=script&lang=js"
export * from "./FileDownloadBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports